import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { AppProvider } from './AppContext';
import PostProperty from './pages/PostProperty';
import ApplyForLoans from './pages/ApplyForLoans';
import EligibilityCalculator from './pages/EligibilityCalculator';
import EMICalculator from './pages/EMICalculator';
import BuyAProperty from './pages/BuyAProperty';
import NoBrokeragePolicy from './pages/NoBrokeragePolicy';
import HomeBuyingGuide from './pages/HomeBuyingGuide';
import HomeWorthCalculator from './pages/HomeWorthCalculator';
import HomeSellingGuide from './pages/HomeSellingGuide';
import RentAProperty from './pages/RentAProperty';
import RentersGuide from './pages/RentersGuide';
import ContactUs from './pages/ContactUs';
import BecomeOurPartner from './pages/BecomeOurPartner';
import KnowledgeCenter from './pages/KnowledgeCenter';
import AboutUs from './pages/AboutUs';

function App() {
  return (
    <div className="bg-gray-50">
      <AppProvider>
        <Router>
        <Routes>
          
          <Route path="/" element={<Home/>} />
          <Route path='/post-property' element={<PostProperty/>}/>
          <Route path='/apply-for-loans' element={<ApplyForLoans/>}/>
          <Route path='/eligibility-calculator' element={<EligibilityCalculator/>}/>
          <Route path='/emi-calculator' element={<EMICalculator/>}/>
          <Route path='/buy-a-property' element={<BuyAProperty/>}/>
          <Route path='/no-brokerage-policy' element={<NoBrokeragePolicy/>}/>
          <Route path='/home-buying-guide' element={<HomeBuyingGuide/>}/>
          <Route path='/home-worth-calculator' element={<HomeWorthCalculator/>}/>
          <Route path='/home-selling-guide' element={<HomeSellingGuide/>}/>
          <Route path='/rent-a-property' element={<RentAProperty/>}/>
          <Route path='/renters-guide' element={<RentersGuide/>}/>
          <Route path='/contact-us' element={<ContactUs/>}/>
          <Route path='/become-our-partner' element={<BecomeOurPartner/>}/>
          <Route path='/knowledge-center' element={<KnowledgeCenter/>}/>
          <Route path='/about-us' element={<AboutUs/>}/>
        
        </Routes>
      </Router>
      </AppProvider>
      
    </div>
  );
}

export default App;
